import { BaseFetch } from "../main-model"
export default class MeasurementModel extends BaseFetch {
  getMeasurementById = (data) =>
    this.authFetch({
      url: "measurement/getMeasurementById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateMeasurementById = (data) =>
    this.authFetch({
      url: "measurement/updateMeasurementById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertMeasurement = (data) =>
    this.authFetch({
      url: "measurement/insertMeasurement",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteMeasurementById = (data) =>
    this.authFetch({
      url: "measurement/deleteMeasurementById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
